<template>
  <StatusAlert
  :id="name"
  :closeBtn="true"
  :showAlert.sync="showAlert">
    <p v-if="status === 'loading'">
      <b-spinner
      style="width: 1rem; height: 1rem;"
      label="Spinning"></b-spinner>
      <span class="status-msg">{{$t('components.file_load_status.loading')}}</span>
    </p>
    <p v-if="status === 'success'">
      <i class="fas fa-check-circle"></i>
      <span class="status-msg">{{$t('components.file_load_status.success')}}</span>
    </p>
    <p v-if="status === 'error'">
      <i class="fas fa-times-circle"></i>
      <span class="status-msg">{{$t('components.file_load_status.error')}}</span>
    </p>
  </StatusAlert>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: null
    },
    status: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function() {
    return {
      showAlert: false
    }
  },
  watch: {
    status: function(newValue) {
      if (newValue == null) this.showAlert = false;
      this.showAlert = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.fa-check-circle {
  color: $warn_green;
  font-size: 1.2rem;
}
.fa-times-circle {
  color: $warn_red;
  font-size: 1.2rem;
}
p {
  display: flex;
  align-items: center;
  margin: 0;
}
p > .status-msg {
  margin-left: 0.6rem;
}
.spinner-border {
  color: $warn_red;
}
</style>